<template>
  <div id="app">
    <TreeSelect
      v-model="idSelected"
      :clearable="false"
      :default-expand-level="1"
      :multiple="hasMultipleSelection"
      :options="tree"
      :placeholder="label"
      :searchable="searchable"
      class="tree-select"
      disable-branch-nodes
      open-direction="bottom"
    >
      <label
        slot="option-label"
        slot-scope="{ node }"
        :class="node.raw.hauteur === 0 ? 'font-weight-bold': ''"
      >
        {{ node.label }}
      </label>
    </TreeSelect>
  </div>
</template>

<script>
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'BaseTreeSelect',
  components: {TreeSelect},
  props: {
    /**
     * @see https://vue-treeselect.js.org/
     * [ {
          id: 'a',
          label: 'a',
          children: [ {
            id: 'aa',
            label: 'aa',
          }, {
            id: 'ab',
            label: 'ab',
          } ],
        }, {
          id: 'b',
          label: 'b',
        }, {
          id: 'c',
          label: 'c',
        } ]
     **/
    tree: {
      type: Array,
      required: true
    },
    selected: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    hasMultipleSelection: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      idSelected: null
    }
  },
  watch: {
    idSelected (newID) {
      this.$emit('change', newID)
    },
    selected: {
      immediate: true,
      handler (newVal) {
        this.idSelected = newVal
      }
    }
  }
}
</script>

<style lang="scss">
.tree-select {
  font-size: 17px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

.vue-treeselect__control {
  height: 56px !important;
}

.vue-treeselect__single-value, .vue-treeselect__placeholder {
  align-items: center !important;
  display: flex;
}

.vue-treeselect-helper-hide {
  display: none !important;
}
</style>
